module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "important-wrap"
  }, [_c('div', {
    staticClass: "important-info"
  }, [_c('el-row', _vm._l((_vm.infoList), function(columnName) {
    return _c('el-col', {
      key: columnName,
      attrs: {
        "span": _vm.columns[columnName].size || _vm.spanCol
      }
    }, [(_vm.formValues) ? _c('info-render', {
      attrs: {
        "data": _vm.formValues[columnName],
        "column": _vm.columns[columnName],
        "minLength": _vm.columns[columnName].minLength,
        "isWrap": _vm.columns[columnName].isWrap
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(props) {
          return [_c('el-row', [_c('el-col', {
            staticStyle: {
              "text-align": "right"
            },
            attrs: {
              "span": _vm.columns[columnName].labelSize || 8
            }
          }, [_c('strong', [_vm._v(_vm._s(_vm.columns[columnName].label) + "：")])]), _vm._v(" "), _c('el-col', {
            staticClass: "flex-right",
            attrs: {
              "span": _vm.columns[columnName].labelSize ? 24 - _vm.columns[columnName].labelSize : 16
            }
          }, [_c('span', [_vm._v(_vm._s(props.content))])])], 1)]
        }
      }])
    }) : _vm._e()], 1)
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47f8bd17","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImportantInfo.vue
// module id = 1747
// module chunks = 1